import {
  VolleyballEventStatusId,
  VolleyballResultId,
} from '@collector/sportsapi-client-legacy'

import { ResultWithSliderConfig } from '../../configuration'

const resultIdToAcronymMap = new Map<VolleyballResultId, string>([
  [VolleyballResultId.FirstSet, 'S1'],
  [VolleyballResultId.SecondSet, 'S2'],
  [VolleyballResultId.ThirdSet, 'S3'],
  [VolleyballResultId.FourthSet, 'S4'],
  [VolleyballResultId.FifthSet, 'S5'],
  [VolleyballResultId.GoldenSet, 'GS'],
])

const eventStatusToResultIdMap = new Map<
  VolleyballEventStatusId,
  VolleyballResultId
>([
  [VolleyballEventStatusId.FirstSet, VolleyballResultId.FirstSet],
  [VolleyballEventStatusId.SecondSet, VolleyballResultId.SecondSet],
  [VolleyballEventStatusId.ThirdSet, VolleyballResultId.ThirdSet],
  [VolleyballEventStatusId.FourthSet, VolleyballResultId.FourthSet],
  [VolleyballEventStatusId.FifthSet, VolleyballResultId.FifthSet],
  [VolleyballEventStatusId.GoldenSet, VolleyballResultId.GoldenSet],
])

export const resultWithSliderConfig: ResultWithSliderConfig<
  VolleyballResultId,
  VolleyballEventStatusId
> = {
  resultIdToAcronymMap,
  eventStatusToResultIdMap,
}
